import { STATUS } from '../../constants/status.constants';

export const profileInitState = {
  status: STATUS.idle,
  data: null,
};
